import { createContext, useContext } from 'react';

export const SiteTypeContext = createContext<string | undefined>(undefined);

export const useSiteType = () => useContext(SiteTypeContext);
